import { IMockProps, ErrorResponseCodeType } from '_core/types';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/MemberDef';
import MocksDef from './MocksDef';

const autoGenerateSuccess = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'PUT',
      path: ENDPOINT_API_PATH,
      body: {
        ...MocksDef.MEMBER_UPDATE,
      },
    },
    configResponse: {
      status: 200,
      data: {
        message: 'Atualização solicitada com sucesso',
        serviceRequestNumber: '1-37462957381',
      },
      headers: {},
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess();

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = () => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'PUT',
          path: ENDPOINT_API_PATH,
          body: {
            ...MocksDef.MEMBER_UPDATE,
            deviceFingerprint: `${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate();
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const UpdateMember = [...generatedSuccessMocks, ...errorsGenerated];
export default UpdateMember;
